// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"663":"1cf62b00","783":"2bca480d","807":"2bca480d","819":"596541ca","967":"2bca480d"}[chunkId] + ".chunk.css";
};